export default "__VITE_ASSET__Bfg6EEvP__"